import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
  selector: '[smlPreventLeadingSpace]',
  standalone: true,
})
export class PreventLeadingSpaceDirective {
  constructor(private readonly el: ElementRef<HTMLInputElement | HTMLTextAreaElement>) { }
  @HostListener('input', ['$event'])
  onInput(): void {
    const inputElement = this.el.nativeElement;
    if (inputElement.value.trimStart() !== inputElement.value) {
      inputElement.value = inputElement.value.trimStart();
    }
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const inputElement = this.el.nativeElement;
    if (event.key === ' ' && inputElement.selectionStart === 0) {
      event.preventDefault();
    }
  }
}
